<template>
  <v-row>
    <v-col cols="5">
      <div>
        <h4>Выберите период</h4>
        <v-select
            v-model="selectedPeriod"
            dense
            :items="periods"
            :loading="selectLoading"
            item-text="name"
            item-value="value"
            @input="check">
        </v-select>
      </div>
    </v-col>
    <v-col cols="7">
      <div>
        <h4>Выберите показатель</h4>
        <v-select
            v-model="selectedSensor"
            dense
            :items="sensors"
            :loading="selectLoading"
            item-text="name"
            item-value="id"
            @input="check">
        </v-select>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { bus } from "@/main"
import axios from "axios";

export default {
  props: {
    sensors: Array,
    postId: Number,
    preSelected: Object
  },
  data: () => ({
    discr: 1,
    periods: [
      {
        value: 1,
        name: "День"
      },{
        value: 7,
        name: "Неделя"
      }
    ],
    selectedPeriod: 1,
    selectedSensor: 0,
    chartOptions: {},
    chartData: {
      labels: [],
      datasets: []
    },
    selectLoading: false
  }),
  methods: {
    check() {
      const periodValues = {
        1: { method: 'setDate', value: -1 },
        7: { method: 'setDate', value: -7 },
        30: { method: 'setMonth', value: -1 },
        365: { method: 'setFullYear', value: -1 }
      };

      const period = periodValues[this.selectedPeriod];

      if (period) {
        const d = new Date();
        const { method, value } = period;

        d[method](d[method.replace("set", "get")]() + value);

        if (this.discr === 4) {
          d.setHours(0, 0, 0, 0);
        }

        this.dtFrom = new Date(Math.floor(d.getTime() / (20 * 1000 * 60)) * (20 * 1000 * 60));
        this.getChartData();
      }
    },
    resetTimeToNearestLower() {
      let currentMinutes = this.dtFrom.getMinutes();
      let copy = new Date(this.dtFrom)

      if (this.dtFrom < 1 || (this.dtFrom === 1 && currentMinutes < 20)) {
        copy.setHours(19);
        copy.setMinutes(20);
        copy.setDate(copy.getDate() - 1)
      } else if (this.dtFrom < 7 || (this.dtFrom === 7 && currentMinutes < 20)) {
        copy.setHours(1);
        copy.setMinutes(20);
      } else if (this.dtFrom < 13 || (this.dtFrom === 13 && currentMinutes < 20)) {
        copy.setHours(7);
        copy.setMinutes(20);
      } else if (this.dtFrom < 19 || (this.dtFrom === 19 && currentMinutes < 20)) {
        copy.setHours(13);
        copy.setMinutes(20);
      } else {
        copy.setHours(19);
        copy.setMinutes(20);
      }

      copy.setSeconds(0);
      copy.setMilliseconds(0);

      return copy
    },
    getChartData() {
      bus.$emit('clean-chart')

      let dtTo = new Date(Math.floor(new Date().getTime() / (20 * 1000 * 60)) * (20 * 1000 * 60))
      const sensorValues = [16, 17, 18, 19, 20];

      let dtFrom = this.dtFrom
      if (sensorValues.includes(this.selectedSensor) && this.discr === 1) {
        dtFrom = this.resetTimeToNearestLower();
      }

      axios
        .post("/air/chart-create", {
          "dt_from": dtFrom,
          "dt_to": dtTo,
          "discr": this.discr,
          "selected_period": this.selectedPeriod,
          "post": {
            "post_id": this.postId,
            "post_sensor": this.selectedSensor
          }
        })
        .then(response => {
          let sensor = this.sensors.find((el) => el.id === this.selectedSensor)

          this.chartData = {labels: [], datasets: []}
          if (this.chartData.datasets.length < 3) {
            this.chartData.datasets.push({
              type: "",
              label: "",
              unit: "",
              data: []
            })
            this.chartData.datasets[0].unit = sensor.unit

            let postscript
            let skip = false
            switch (this.discr) {
              case 1:
                postscript = "м.р."
                if (sensor.pdk_hour === null) {
                  this.chartData.datasets[0].label = sensor.name
                  skip = true
                } else {
                  this.chartData.datasets[0].label = "< ПДК " + postscript
                }
                break
              case 4:
                postscript = "с.с."
                if (sensor.pdk_day === null) {
                  this.chartData.datasets[0].label = sensor.name
                  skip = true
                } else {
                  this.chartData.datasets[0].label = "< ПДК " + postscript
                }
                break
            }

            if (sensor.is_weather === false || sensor.name === "Температура воздуха") {
              this.chartData.datasets[0].type = "bar"
              if (!skip) {
                this.chartData.datasets.push({
                  type: "bar",
                  label: "> ПДК " + postscript,
                  unit: sensor.unit,
                  data: []
                })

                this.chartData.datasets.push({
                  type: "line",
                  label: "ПДК " + postscript,
                  unit: sensor.unit,
                  data: []
                })
              }
            } else {
              this.chartData.datasets[0].type = "line"
            }
          }

          let datasets = this.chartData.datasets
          const passingKeyValue = (response) => {
            for (let [_, outerValue] of Object.entries(response.data)) {
              for (let [innerKey, innerValue] of Object.entries(outerValue)) {
                let date = new Date(innerKey * 1000)
                let month = date.getMonth() + 1
                let dateFormat
                switch (this.discr) {
                  case 1:
                    dateFormat = date.getDate() + "." + month + " " + date.getHours() + ":" + date.getMinutes()
                        break
                  case 4:
                    dateFormat = date.getDate() + "." + month + " " + date.getFullYear()
                        break
                }

                this.chartData.labels.push(dateFormat.replace(/(^|\D)(\d)(?!\d)/g, '$10$2'))
                if (datasets.length === 1) {
                  datasets[0].data.push(innerValue.b)
                }
                if (datasets.length === 3) {
                  if (typeof innerValue.b === 'undefined') {
                    datasets[0].data.push(null)
                  } else {
                    datasets[0].data.push(innerValue.b)
                  }

                  if (typeof innerValue.h === 'undefined') {
                    datasets[1].data.push(null)
                  } else {
                    datasets[1].data.push(innerValue.h)
                  }

                  switch (this.discr) {
                    case 1:
                      datasets[2].data.push(sensor.pdk_hour)
                      break
                    case 4:
                      datasets[2].data.push(sensor.pdk_day)
                      break
                  }
                }
              }
            }
          }

          passingKeyValue(response)
          this.customizeChart()

          let name = sensor.name
          let period = this.selectedPeriod
          let discr = this.discr

          bus.$emit('chart-data', {data: this.chartData, options: this.chartOptions})
          bus.$emit('pre-install-selected', {name, period, discr})
        })
        .catch(err => {
          bus.$emit('err-listen', {text: 'Ошибка при отображении графика'})
          console.log(err)
        })
    },
    customizeChart() {
      const commonChartOptions = {
          animation: false,
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: 'xy',
              },
              limits: {
                y: {min: 0, max: 0},
              },
              zoom: {
                wheel: {
                  enabled: true,
                  mode: 'x',
                }
              },
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ' в ' + this.chartData.datasets[0].unit + ' : ';
                  }
                  if (context.parsed.y !== null) {
                    label += context.parsed.y.toFixed(4);
                  }
                  return label;
                }.bind(this),
              }
            }
          },
        };

      if (this.discr === 4) {
        this.chartOptions = {...commonChartOptions};
      } else if (this.discr === 1) {
        this.chartOptions = {
          ...commonChartOptions,
          plugins: {
            ...commonChartOptions.plugins,
            tooltip: {
              ...commonChartOptions.plugins.tooltip,
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ' : ';
                  }
                  if (context.parsed.y !== null) {
                    label += context.parsed.y.toFixed(4) + " " + this.chartData.datasets[0].unit;
                  }
                  return label;
                }.bind(this),
              },
            },
          },
        };
      }

      const getMaxValue = (data) => Math.max(...data);
      const getMinValue = (data) => Math.min(...data);

      const c1 = getMaxValue(this.chartData.datasets[0].data);
      const c2 = this.chartData.datasets.length > 1 ? getMaxValue(this.chartData.datasets[1].data) : 0;
      const c3 = this.chartData.datasets.length > 2 ? this.chartData.datasets[2].data[0] : 0;

      const getMaxY = () => {
        const maxY = Math.max(c1, c2, c3) + Number(Math.max(c1, c2, c3) / 100 * 20);
        return maxY === 0 ? 1 : maxY;
      };

      const setBarChartOptions = () => {
        this.chartData.datasets[0].backgroundColor = 'rgba(54,162,235,0.5)';
        this.chartData.datasets[0].borderColor = 'rgb(0,151,255)';
        if (this.chartData.datasets.length > 2) {
          this.chartData.datasets[1].backgroundColor = 'rgba(231,37,37,0.5)';
          this.chartData.datasets[1].borderColor = 'rgb(255,0,0)';

          this.chartData.datasets[2].pointRadius = '0';
          this.chartData.datasets[2].pointStyle = 'line';
          this.chartData.datasets[2].borderColor = function () {
            return 'rgb(255,0,0, 0.7)';
          };
          this.chartData.datasets[2].borderWidth = 1;
        }

        if (this.sensors.find(x => x.id === this.selectedSensor).name === "Температура воздуха") {
          this.chartData.datasets[0].backgroundColor = function (context) {
            return this.airTemperatureCustom(context, 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)');
          }.bind(this);
          this.chartData.datasets[0].borderColor = function (context) {
            return this.airTemperatureCustom(context, 'rgb(255, 99, 132)', 'rgb(54, 162, 235)');
          }.bind(this);
        }
      };

      const setLineChartOptions = () => {
        this.chartData.datasets[0].pointStyle = 'circle';
        this.chartData.datasets[0].pointRadius = '2';
        this.chartData.datasets[0].pointBackgroundColor = 'rgba(0,103,169,0.5)';
        this.chartData.datasets[0].pointBorderColor = 'rgba(0,103,169,0.5)';
        this.chartData.datasets[0].borderColor = 'rgba(145,145,145,0.86)';
        this.chartData.datasets[0].pointHoverRadius = '2';
        this.chartData.datasets[0].borderWidth = 2;
      };

      this.chartOptions.plugins.zoom.limits.y.max = getMaxY();
      this.chartOptions.plugins.zoom.limits.y.min = getMinValue(this.chartData.datasets[0].data) > 0 ?
          0 : getMinValue(this.chartData.datasets[0].data);

      if (this.chartData.datasets[0].type === "bar") {
        setBarChartOptions();
      } else {
        setLineChartOptions();
      }

      this.chartData.datasets[0].borderWidth = 1
    },
    airTemperatureCustom(context, col1, col2) {
      let index = context.dataIndex;
      let value = context.dataset.data[index];
      return value > 0 ? col1 : col2
    },
    switchDiscreteness(discr) {
      this.discr = discr;
      switch (this.discr) {
        case 1:
          this.periods = [
            {
              value: 1,
              name: "День"
            },{
              value: 7,
              name: "Неделя"
            }
          ]
          this.selectedPeriod = 1

          break
        case 4:
          this.periods = [
            {
              value: 7,
              name: "Неделя"
            },
            {
              value: 30,
              name: "Месяц"
            },
            {
              value: 365,
              name: "Год"
            }
          ]
          if (this.preSelected.period === 1) {
            this.selectedPeriod = 7
          }

          break
      }
      this.check()
    }
  },
  created() {
    let sensor = this.sensors.find((el) => el.name === this.preSelected.sensorName)

    this.discr = this.preSelected.discr
    if (typeof sensor !== 'undefined') {
      this.selectedSensor = sensor.id
      this.selectedPeriod = this.preSelected.period
    } else {
      this.selectedSensor = this.sensors[0].id
      this.selectedPeriod = this.preSelected.period
    }

    bus.$off('discr-switch')
    bus.$on('discr-switch', (value) => {
      this.switchDiscreteness(value.discr)
    })

    bus.$off('select-loading')
    bus.$on('select-loading', (value) => {
      this.selectLoading = value
    })

    if (this.discr === 1) {
      this.check()
    }
  }
}
</script>